import { createAction } from 'redux-api-middleware'
import type { RootState } from '../../reducers'
import { HUBBLE_API_TOKEN } from '../../store/middleware/APIUrl'
import type { Credit } from '../../types'
import ActionTypes from './actionTypes'

type FetchCreditRequest = {
    type: typeof ActionTypes.CREDIT_ID_FETCH_REQUEST;
    payload: never;
}

type FetchCreditFailure = {
    type: typeof ActionTypes.CREDIT_ID_FETCH_FAILURE;
    payload: Error;
}

type FetchCreditSuccess = {
    type: typeof ActionTypes.CREDIT_ID_FETCH_SUCCESS;
    payload: Credit;
}

/**
 * Fetch one credit given its ID
 */
function fetchCredit(id: number) {
    return createAction<RootState, Credit, never>({
        endpoint: `${HUBBLE_API_TOKEN}/credits/${id}`,
        method: 'GET',
        types: [
            ActionTypes.CREDIT_ID_FETCH_REQUEST,
            ActionTypes.CREDIT_ID_FETCH_SUCCESS,
            ActionTypes.CREDIT_ID_FETCH_FAILURE,
        ],
    })
}

export type FetchCreditAction = FetchCreditRequest
    | FetchCreditFailure
    | FetchCreditSuccess

export default fetchCredit
